import React, { useState, lazy } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import parse from "html-react-parser";
import experience from "../../Assets/Red_Theme/experience.png";
import description from "../../Assets/Red_Theme/description.png";
import "./Career.scss";

const Swal = lazy(() => import("sweetalert2"));

const JOB_LISTINGS = [
  {
    id: "1",
    title: "HR Executive",
    experience: "1 – 3 Years",
    description:
      "We are looking for a proactive and people-focused HR Executive to manage end-to-end human resource operations and support organizational growth. The ideal candidate should have hands-on experience in recruitment, employee engagement, HR operations, and compliance. This role requires strong communication skills, attention to detail, and the ability to handle multiple HR responsibilities efficiently. The HR Executive will act as a bridge between management and employees, ensuring smooth HR processes and a positive work environment.",
    jobType: "Full-Time",
    location: "On-Site",
    industry: "Information Technology",
    skills:
      `<ul>
      <li>Strong verbal and written communication skills</li>
      <li>Good interpersonal and conflict-resolution abilities</li>
      <li>Knowledge of HR processes, labor laws, and compliance</li>
      <li>Experience in IT hiring (developers, designers, QA, etc.)</li>
      <li>Proficiency in HRMS / ATS tools</li>
      <li>Knowledge of payroll coordination and attendance management</li>
      <li>Strong organizational and documentation skills</li>
      <li>Ability to maintain confidentiality and professionalism</li>
      <li>Proficiency in Microsoft Office (Excel, Word, Outlook)</li>
      </ul>`,
    recruitmentTalentAcquisition:
      `<ul>
      <li>Handle end-to-end recruitment process</li>
      <li>Post job openings on job portals, LinkedIn, and other platforms</li>
      <li>Screen resumes and shortlist candidates</li>
      <li>Schedule and coordinate interviews with technical teams</li>
      <li>Conduct initial HR interviews</li>
      <li>Manage offer letters, salary discussions, and onboarding</li>
      </ul>`,
    onboardingOffboarding:
      `<ul>
      <li>Manage joining formalities and documentation</li>
      <li>Conduct employee induction and orientation</li>
      <li>Ensure smooth exit process including clearance and documentation</li>
      </ul>`,
    hrOperations:
      `<ul>
      <li>Maintain employee records and HR documentation</li>
      <li>Track attendance, leaves, and employee data</li>
      <li>Support payroll inputs and coordination</li>
      <li>Maintain HR policies and ensure employees follow company guidelines</li>
      </ul>`,
    employeeEngagementRelations:
      `<ul>
      <li>Address employee concerns and grievances</li>
      <li>Organize employee engagement activities</li>
      <li>Promote a positive and productive work culture</li>
      <li>Support performance review processes</li>
      </ul>`,
    compliancePolicies:
      `<ul>
      <li>Ensure adherence to company policies and HR procedures</li>
      <li>Assist in maintaining statutory compliance and documentation</li>
      <li>Support in drafting HR policies and internal communications</li>
      </ul>`,
    performanceManagement:
      `<ul>
      <li>Assist managers in performance appraisal cycles</li>
      <li>Track performance feedback and documentation</li>
      </ul>`,
    preferred:
      `<ul>
      <li>Bachelor's degree in HR, Business Administration, or related field</li>
      <li>Experience in IT / Software company hiring</li>
      <li>Familiarity with platforms like LinkedIn, Naukri, Indeed, etc.</li>
      <li>Basic knowledge of labor laws and HR compliance</li>
      </ul>`,
    lookingFor:
      `<ul>
      <li>Self-driven and responsible</li>
      <li>Good at handling multiple tasks</li>
      <li>Strong follow-up and coordination skills</li>
      <li>Professional attitude and positive mindset</li>
      <li>Ability to work in a fast-paced environment</li>
      </ul>`,
  }
  // {
  //   id: "2",
  //   title: "Trainee - Flutter Developer",
  //   experience: "",
  //   description:
  //     "We are looking for a skilled and passionate Flutter Developer to join our team! As a Flutter Developer, you will be responsible for building beautiful, performant, and feature-rich mobile applications using Flutter. You will work closely with designers, product managers, and other developers to bring cutting-edge ideas to life on both iOS and Android platforms.",
  //   skills:
  //     "<ul><li>Dart Programming Language</li><li>Flutter Framework</li><li>Mobile Development Basics</li><li>API Integration</li><li>State Management</li><li>UI/UX Design Principles</li><li>Testing and Debugging</li><li>Version Control Systems</li><li>Platform-Specific Skills</li><li>Performance Optimization</li><li>Problem-Solving</li><li>Team Collaboration</li><li>Learning Agility</li><li>IDEs</li><li>Database Management</li><li>Deployment</li><li>CI/CD Tools</li></ul>",
  //   responsibilities:
  //     "<ul><li>Proficient in Flutter and Dart for building cross-platform mobile applications.</li><li>Strong expertise in integrating RESTful APIs, GraphQL, and WebSocket.</li><li>Skilled in local (SQLite, Hive) and cloud (Firebase Firestore) database management.</li><li>Advanced knowledge of state management solutions like GetX, Provider, and Bloc.</li><li>Proven experience in app performance optimisation for speed and memory efficiency.</li><li>Strong ability to manage and lead a development team effectively.</li><li>Excellent client communication skills for requirement gathering and updates.</li><li>Expertise in project planning, work allocation, and Agile methodologies.</li><li>Proficient in deploying apps to Google Play Store and Apple App Store.</li><li>Hands-on experience with Git and CI/CD pipelines for automated workflows.</li><li>Skilled in creating responsive, pixel-perfect UIs and animations.</li><li>Strong problem-solving skills and ability to deliver projects on time.</li></ul>",
  // },
  // {
  //   id: "3",
  //   title: "Trainee - MERN Stack Developer",
  //   experience: "",
  //   description:
  //     "We are looking for a MERN Stack Developer responsible for managing back-end services and the interchange of data between the server and the users. You will also be responsible for integrating the front-end elements built by your co-workers into the application. Therefore, a basic understanding of front-end technologies is necessary as well.",
  //   skills:
  //     "<ul><li>Node Js experience must required</li><li>M – MongoDB [ Database ]</li><li>E - Express JS [ Server side ] – node js web framework</li><li>R – React JS - a client side JavaScript framework</li><li>N - Node js [Back end technology] - the premier JavaScript web server.</li></ul>",
  // },
  // {
  //   id: "4",
  //   title: "Trainee - Mean Stack Developer",
  //   experience: "",
  //   description:
  //     "We are looking for an Mean Stack Developer that will be able to develop and support existing applications. The main scope of work will include everything from back-end to client-side code, using optimal and efficient technologies, frameworks, and patterns. Your primary responsibilities will be to design and develop these applications. Therefore, it's essential that you are skilled at problem solving, solution design, and high-quality coding",
  //   skills:
  //     "<ul><li>Node Js experience must required</li><li>M – MongoDB [ Database ]</li><li>E - Express JS [ Server side ] – node js web framework</li><li>A - Angular - a client side JavaScript framework – version 9+</li><li>N - Node js [Back end technology] - the premier JavaScript web server.</li></ul>",
  // },
  // {
  //   id: "5",
  //   title: "Trainee - UI/UX Designer",
  //   experience: "",
  //   description:
  //     "We are seeking a talented and creative UI/UX Designer to join our team! As a UI/UX Designer, you will be responsible for designing intuitive, user-friendly, and visually appealing interfaces that enhance user experiences. You will collaborate closely with product managers, developers, and stakeholders to translate requirements into compelling designs and ensure seamless functionality across various platforms.",
  //   skills:
  //     "<ul><li>Design Principles</li><li>Wireframing & Prototyping</li><li>User Research</li><li>Information Architecture</li><li>Responsive Design</li><li>HTML/CSS Basics</li><li>Animation and Interaction</li></ul>",
  //   tools:
  //     "<ul><li>Design and Prototyping Tools - Figma, Adobe XD, Sketch, Axure RP, InVision.</li><li>Graphic Design Tools - Adobe Photoshop, Adobe Illustrator, CorelDRAW.</li><li>User Research Tools - Optimal Workshop, UsabilityHub, Hotjar.</li><li>Collaboration Tools - Miro, Zeplin, Slack.</li><li>3D & Animation Tools - Adobe After Effects, Principle, Lottie.</li><li>UI Libraries - Material Design, Human Interface Guidelines (HIG), and other design systems.</li></ul>",
  //   responsibilities:
  //     "<ul><li>Design and deliver wireframes, prototypes, user flows, and mockups optimized for various devices and interfaces.</li><li>Create and maintain design systems, style guides, and UI components to ensure consistency across the product.</li><li>Collaborate with cross-functional teams to define user requirements and deliver engaging solutions.</li><li>Stay updated with the latest design trends, tools, and technologies to enhance creativity and innovation.</li></ul>",
  // },
  // {
  //   id: "7",
  //   title: "Business Analyst",
  //   experience: "2 Years",
  //   description:
  //     "We are looking for a motivated and detail-oriented Business Analyst with 2 years of experience to join our team. The ideal candidate will be responsible for understanding business needs, analyzing processes, and proposing effective solutions that support strategic decision-making. You will work closely with stakeholders, product teams, and developers to translate requirements into functional specifications and ensure successful project execution.",
  //   skills:
  //     "<ul><li>Requirement Gathering</li><li>Business Process Mapping</li><li>Data Analysis & Reporting</li><li>Documentation & Technical Writing</li><li>Stakeholder Communication</li><li>Analytical Thinking</li><li>Problem Solving</li></ul>",
  //   tools:
  //     "<ul><li>Business Analysis Tools – JIRA, Confluence, Trello, Asana.</li><li>Data & Reporting Tools – Excel, Google Sheets, Power BI, Tableau.</li><li>Modeling Tools – Draw.io, Lucidchart, MS Visio.</li><li>Collaboration Tools – Slack, Teams, Notion.</li><li>SQL Basics for Data Extraction.</li></ul>",
  //   responsibilities:
  //     "<ul><li>Conduct requirement gathering sessions and translate business needs into detailed documentation.</li><li>Analyze current business processes and identify areas for optimization.</li><li>Create functional specifications, user stories, and acceptance criteria.</li><li>Collaborate with product managers and developers to ensure accurate implementation.</li><li>Support testing activities by validating requirements and identifying issues.</li><li>Prepare reports, dashboards, and insights to assist decision-making.</li></ul>",
  // },
  // {
  //   id: "8",
  //   sequence_id: "7",
  //   title: "Senior - Node JS Developer",
  //   image: "nodejs-senior.webp",
  //   experience: "5+ Years",
  //   description:
  //     "We are seeking an experienced Senior Node JS Developer (Team Lead) with strong expertise in backend development, API architecture, and team leadership. The ideal candidate will guide the engineering team, design scalable backend solutions, and ensure high-quality code delivery.",
  //   skills: `
  //     <ul>
  //       <li>Advanced JavaScript and TypeScript</li>
  //       <li>Node.js Core Concepts</li>
  //       <li>REST API & Microservices Architecture</li>
  //       <li>Database Design (MongoDB, MySQL, PostgreSQL)</li>
  //       <li>Authentication & Authorization (JWT, OAuth)</li>
  //       <li>Scalable Backend Architecture</li>
  //       <li>Team Leadership & Code Reviews</li>
  //       <li>Agile Development Practices</li>
  //     </ul>
  //   `,
  //   tools: `
  //     <ul>
  //       <li>Node.js Frameworks – Express.js, NestJS, Koa</li>
  //       <li>Database Tools – Mongoose, Prisma, Sequelize, TypeORM</li>
  //       <li>Cloud Platforms – AWS, DigitalOcean, GCP</li>
  //       <li>Version Control – Git, GitHub, GitLab</li>
  //       <li>API Documentation – Swagger, Postman</li>
  //       <li>Containerization – Docker, Kubernetes (basic)</li>
  //       <li>CI/CD – GitHub Actions, Jenkins</li>
  //     </ul>
  //   `,
  //   other_skills: null,
  //   responsibilities: `
  //     <ul>
  //       <li>Lead a team of backend developers and ensure high-quality code delivery.</li>
  //       <li>Architect, design, and maintain scalable backend systems and APIs.</li>
  //       <li>Review code, mentor junior developers, and enforce engineering best practices.</li>
  //       <li>Collaborate with frontend, QA, and product teams to deliver features on time.</li>
  //       <li>Optimize application performance and ensure system reliability.</li>
  //       <li>Implement DevOps practices and improve development workflows.</li>
  //       <li>Stay updated with the latest backend technologies and Node.js ecosystem trends.</li>
  //     </ul>
  //   `
  // },
  // {
  //   id: "9",
  //   sequence_id: "8",
  //   title: "Junior - Node JS Developer",
  //   image: "nodejs-junior.webp",
  //   experience: "1+ Year",
  //   description:
  //     "We are hiring a Junior Node JS Developer with a minimum of 1 year of hands-on experience in backend development. The ideal candidate should have a solid understanding of Node.js fundamentals and the enthusiasm to learn and grow within the team.",
  //   skills: `
  //     <ul>
  //       <li>JavaScript (ES6+) Basics</li>
  //       <li>Node.js Fundamentals</li>
  //       <li>REST API Development</li>
  //       <li>Database Basics (MongoDB or MySQL)</li>
  //       <li>Debugging & Problem Solving</li>
  //       <li>Understanding of Async Programming</li>
  //       <li>Basic Git Knowledge</li>
  //     </ul>
  //   `,
  //   tools: `
  //     <ul>
  //       <li>Node.js Frameworks – Express.js, NestJS (basic understanding)</li>
  //       <li>Database Tools – Mongoose or Sequelize</li>
  //       <li>API Testing – Postman, Thunder Client</li>
  //       <li>Version Control – Git, GitHub</li>
  //       <li>Project Management Tools – Jira, Trello</li>
  //       <li>Basic Understanding of Docker (optional)</li>
  //     </ul>
  //   `,
  //   other_skills: null,
  //   responsibilities: `
  //     <ul>
  //       <li>Develop and maintain backend features using Node.js.</li>
  //       <li>Build APIs and integrate third-party services.</li>
  //       <li>Write clean, modular, and well-documented code.</li>
  //       <li>Work closely with senior developers to deliver project requirements.</li>
  //       <li>Participate in team meetings, code reviews, and testing cycles.</li>
  //       <li>Troubleshoot bugs and enhance existing application modules.</li>
  //       <li>Continuously learn and improve skills in backend development.</li>
  //     </ul>
  //   `
  // }  
];

function Career() {
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [expandedJob, setExpandedJob] = useState(null);

  const { register, formState: { errors }, handleSubmit, reset } = useForm();

  const handleResumeUpload = (e) => {
    setResume(e.target.files[0]);
  };

  // const handleApplyClick = (jobId) => {
  //   setShowApplyForm(true);
  // };

  const handleCloseForm = () => {
    setShowApplyForm(false);
    setServerError("");
    reset();
  };

  const toggleJobDetails = (index) => {
    setExpandedJob(expandedJob === index ? null : index);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    setLoading(true);
    setServerError("");

    const formData = new FormData();
    formData.append("job", data.jobTitle);
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("mobile", data.mobile);
    formData.append("salary", data.currentSalary);
    formData.append("experience", data.totalExperience);
    formData.append("experience_in", data.experienceUnit);
    formData.append("resume", resume);
    formData.append("message", data.message);

    try {
      const response = await fetch(
        `http://viapi.vidhaninfotech.com/api/apply-now`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        await Swal.fire({
          title: "Your application has been sent successfully.",
          text: "We'll analyze your information and get back to you ...",
          icon: "success",
        });
        handleCloseForm();
      } else {
        setServerError(result.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setServerError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderJobDetail = (label, content) => {
    if (!content) return null;
    return (
      <ul className="responsibility">
        <span className="title">{label}</span>
        <span></span>
        {parse(content)}
      </ul>
    );
  };

  return (
    <>
      <section className="career">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title mb-4">
                <h4 className="line_title">Team</h4>
                <h1>
                  Join <span>Our Team</span>
                </h1>
                <p>
                  Send your resume to our HR Team on WhatsApp{" "}
                  <Link
                    to="https://wa.me/918780838782"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#cbcbcb" }}
                  >
                    +91 8780-838-782
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {JOB_LISTINGS.map((job, index) => (
              <div className="col-md-6 col-lg-4" key={job.id}>
                <div
                  className={`career_box ${expandedJob === index ? "view_more_active" : ""
                    }`}
                  id={`career_box${index}`}
                >
                  <h2>{job.title}</h2>

                  {job.experience && (
                    <div className="d-flex gap-3 mb-4">
                      <img src={experience} className="img-fluid" alt="" />
                      <h5>
                        <span className="title">Experience</span>
                        {job.experience}
                      </h5>
                    </div>
                  )}

                  <div className="d-flex gap-3 mb-4">
                    <img src={description} className="img-fluid" alt="" />
                    <p className={`${expandedJob === index ? "" : "fourLine"}`}>
                      <span className="title">Description</span>{" "}
                      {job.description}
                    </p>
                  </div>

                  <div className="viewmore_data">
                    {job.jobType && (
                      <div className="d-flex gap-2">
                        <h5>
                          <b>Job Type:</b>
                        </h5>
                        <p className="text-bg-dark m-0">{job.jobType}</p>
                      </div>
                    )}

                    {job.location && (
                      <div className="d-flex gap-2">
                        <h5>
                          <b>Location:</b>
                        </h5>
                        <p className="text-bg-dark m-0">{job.location}</p>
                      </div>
                    )}

                    {job.industry && (
                      <div className="d-flex gap-2">
                        <h5>
                          <b>Industry:</b>
                        </h5>
                        <p className="text-bg-dark m-0">{job.industry}</p>
                      </div>
                    )}

                    {renderJobDetail("Skills", job.skills)}
                    {renderJobDetail("Tools", job.tools)}
                    {renderJobDetail("Recruitment & Talent Acquisition", job.recruitmentTalentAcquisition)}
                    {renderJobDetail("Employee Onboarding & Offboarding", job.onboardingOffboarding)}
                    {renderJobDetail("HR Operations", job.hrOperations)}
                    {renderJobDetail("Employee Engagement & Relations", job.employeeEngagementRelations)}
                    {renderJobDetail("Compliance & Policies", job.compliancePolicies)}
                    {renderJobDetail("Performance Management Support", job.performanceManagement)}
                    {renderJobDetail("Responsibilities", job.responsibilities)}
                    {renderJobDetail("Client Engagement", job.clientEngagement)}
                    {renderJobDetail("Proposal Writing Negotiation", job.proposalWritingNegotiation)}
                    {renderJobDetail("Market Research Analysis", job.marketResearchAnalysis)}
                    {renderJobDetail("Collaboration with Teams", job.collaborationWithTeams)}
                    {renderJobDetail("Preferred Qualifications", job.preferred)}
                    {renderJobDetail("What We're Looking For in a Candidate", job.lookingFor)}
                  </div>

                  <button
                    className="view_more"
                    onClick={() => toggleJobDetails(index)}
                  >
                    {expandedJob === index ? "View Less" : "View More"}
                    <MdOutlineArrowRightAlt className="icon" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className={`apply_now_back ${showApplyForm ? "active" : ""}`}>
            <button className="close" onClick={handleCloseForm}>
              +
            </button>
            <div className="apply_now">
              <form
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
                encType="multipart/form-data"
              >
                <div className="row">
                  <div className="col-md-12">
                    <select {...register("jobTitle", { required: true })}>
                      <option value="" disabled>
                        Select Job
                      </option>
                      {JOB_LISTINGS.map((job) => (
                        <option key={job.id} value={job.id}>
                          {job.title}
                        </option>
                      ))}
                    </select>
                    {errors.jobTitle && (
                      <span className="error_msg">Job is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      {...register("name", { required: true })}
                      placeholder="Name"
                    />
                    {errors.name && (
                      <span className="error_msg">Name is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      {...register("email", { required: true })}
                      placeholder="Email"
                    />
                    {errors.email && (
                      <span className="error_msg">Email is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      {...register("mobile", { required: true })}
                      placeholder="Mobile Number"
                    />
                    {errors.mobile && (
                      <span className="error_msg">Mobile number is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      type="number"
                      min="1"
                      {...register("currentSalary", { required: true })}
                      placeholder="Monthly Salary"
                    />
                    {errors.currentSalary && (
                      <span className="error_msg">Salary is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      type="text"
                      {...register("totalExperience", { required: true })}
                      placeholder="Total Experience"
                    />
                    {errors.totalExperience && (
                      <span className="error_msg">Total Experience is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <select {...register("experienceUnit", { required: true })}>
                      <option value="" disabled>
                        Select MM/YY
                      </option>
                      <option value="year">Year</option>
                      <option value="month">Month</option>
                    </select>
                    {errors.experienceUnit && (
                      <span className="error_msg">Experience unit is required</span>
                    )}
                  </div>

                  <div className="col-md-6">
                    <input
                      type="file"
                      id="files"
                      onChange={handleResumeUpload}
                      accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      {...register("message", { required: true })}
                      placeholder="Message"
                    />
                    {errors.message && (
                      <span className="error_msg">Message is required</span>
                    )}
                  </div>

                  {serverError && (
                    <div className="col-md-12">
                      <span className="error_msg">{serverError}</span>
                    </div>
                  )}

                  <div className="col-md-12">
                    <button
                      type="submit"
                      disabled={loading}
                      className={loading ? "Loadingbtn" : ""}
                    >
                      {loading ? "Loading..." : "Send"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default React.memo(Career);